import React, { useState } from "react";
import FooterThree from "../../common/Footer/FooterThree";
import Menu from "../../common/Menu/Menu";
import ContactWithTeam from "./ContactWithTeam";
import SingleTeamBanner from "./SingleTeamBanner";
import TeamDetailsAbout from "./TeamDetailsAbout";
import TeamDetailsHero from "./TeamDetailsHero";
import ElevatorLoader from "../../Loder/ElevatorLoader";

const TeamDetails = () => {
  const [loading, setLoading] = useState(true);
  return (
    <div>
      {loading && <ElevatorLoader onFinish={() => setLoading(false)} />}
      <Menu header_style_2={true} />
      <SingleTeamBanner />
      <TeamDetailsHero />
      <TeamDetailsAbout />
      <ContactWithTeam />
      <FooterThree />
    </div>
  );
};

export default TeamDetails;
